import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

// ======================== Banner Functions ========================

/**
 * Lấy danh sách Banner
 */
export const fetchLoadingBanner = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/image/banner`);
    return response.data.banners || [];
  } catch (error) {
    console.error('Error fetching banner:', error);
    throw error.response?.data || { message: 'Failed to fetch banner' };
  }
};

/**
 * Upload Banner mới
 */
export const fetchUploadBanner = async (file) => {
  try {
    const formData = new FormData();
    formData.append('url', file);

    const response = await axios.post(`${BASE_URL}/api/image/banner`, formData);
    return response.data.banner;
  } catch (error) {
    console.error('Error uploading banner:', error);
    throw error.response?.data || { message: 'Failed to upload banner' };
  }
};

/**
 * Sửa Banner
 */
export const fetchEditBanner = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL}/api/image/banner/${id}`, formData);
    return response.data.banner;
  } catch (error) {
    console.error('Error editing banner:', error);
    throw error.response?.data || { message: 'Failed to edit banner' };
  }
};

/**
 * Xóa Banner
 */
export const fetchDeleteBanner = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/api/image/banner/${id}`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error deleting banner:', error);
    throw error.response?.data || { message: 'Failed to delete banner' };
  }
};

// ======================== Default Export ========================
export default {
  fetchLoadingBanner,
  fetchUploadBanner,
  fetchEditBanner,
  fetchDeleteBanner,
};

